import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNigeriaFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8534_5012)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M30 59.9985C46.5685 59.9985 60 46.5671 60 29.9985C60 13.43 46.5685 -0.00146484 30 -0.00146484C13.4315 -0.00146484 0 13.43 0 29.9985C0 46.5671 13.4315 59.9985 30 59.9985Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 29.9982C0 42.8972 8.14125 53.8934 19.5653 58.1323V1.86426C8.14125 6.10293 0 17.0993 0 29.9982Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60 29.9982C60 17.0993 51.8587 6.10293 40.4347 1.86426V58.1324C51.8587 53.8934 60 42.8972 60 29.9982Z",
				fill: "#6DA544"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8534_5012",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60,
			fill: "white",
			transform: "translate(0 -0.00146484)"
		})
	}) })]
});
export default SvgNigeriaFlag;
